/* Baja Llama - notify-me size fix.  Added 2026-10-25.

   BUG
   The theme's "Sold out - notify me when it's available" form is rendered once,
   for whichever size was selected when the page loaded (usually Small). When a
   shopper picks a different sold-out size, the button appears but the form
   still says the first size, and the email the store receives says
   "Road Runner - S" even though they wanted M.

   FIX
   Listen for the theme's own variant change event and rewrite the size label,
   the hidden "product" field, and the form id to match the selected variant.

   TO REVERT: delete the single script line for this file in layout/theme.liquid.
*/
(function () {
  'use strict';

  function apply(variant) {
    if (!variant || !variant.title) return;
    document.querySelectorAll('product-notification').forEach(function (n) {
      var label = n.querySelector('[data-variant-title]');
      if (label) label.textContent = variant.title;

      var field = n.querySelector('[data-notification-product]');
      if (field) {
        var h = n.querySelector('.product__notification__title');
        var title = h ? h.textContent.trim() : '';
        field.value = title + ' - ' + variant.title;
      }

      var form = n.querySelector('form');
      if (form && form.id) form.id = form.id.replace(/--\d+$/, '--' + variant.id);
    });
  }

  function init() {
    if (typeof window.subscribe !== 'function' || !window.theme || !theme.PUB_SUB_EVENTS) {
      return window.setTimeout(init, 200);
    }
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function (e) {
      apply(e && e.data && e.data.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
